import React, { Component } from 'react';
import { Text, View, Pressable, Image, StyleSheet } from 'react-native';

import OPComponent from '../op_component';
import { COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';
import { SHADOW_STYLE } from './style';

export default class MenuItem extends OPComponent {
  constructor(props) {
    super(props);
  }

  handlePress = () => {
    this.props.onPress && this.props.onPress(this.props.item);
  };

  render() {
    const { label, iconSource, iconStyle } = this.props.item;
    return (
      <Pressable style={styles.menuItemButton} onPress={this.handlePress}>
        <Text style={styles.menuItemText}>{label}</Text>
        <View style={styles.menuItemIconContainer}>
          <Image
            style={[styles.menuItemIcon, this.props.iconStyle, iconStyle]}
            source={iconSource}
            resizeMode="contain"
          />
        </View>
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  menuItemButton: {
    height: 66,
    paddingHorizontal: 10,
    flexDirection: 'row',
    alignItems: 'center',
    // backgroundColor: 'pink'
  },
  menuItemText: {
    ...FONT.medium,
    fontSize: 16,
    color: 'black',
    marginRight: 20,
  },
  menuItemIconContainer: {
    ...SHADOW_STYLE,
    width: 44,
    height: 44,
    borderRadius: 22,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
  },
  menuItemIcon: {
    width: 28,
    height: 28,
    // tintColor: COLOR.textLight,
    // backgroundColor: 'pink'
  },
});
